import { Fragment, useState } from 'react'
import { useAppSelector } from '../../ReduxToolkit/Hooks';
import { H6, LI } from '../../AbstractElements';
// Usar el menú simplificado de negocio en lugar del menú completo
// El menú completo original se mantiene en '../../Data/Layout/Sidebar' por si se necesita en el futuro
import { BusinessMenuList } from '../../Data/Layout/BusinessSidebar';
import { MenuItem } from '../../Types/Layout/Sidebar';
import MenuLists from './MenuLists';
import { useTranslation } from 'react-i18next';

const SidebarMenuList = () => {
    const [activeMenu, setActiveMenu] = useState<string[]>([]);
    const { t } = useTranslation(); 
    const { pinedMenu } = useAppSelector((state) => state.layout);
    const shouldHideMenu = (mainMenu: MenuItem) => {return mainMenu?.Items?.map((data) => data.title).every((titles) =>pinedMenu.includes(titles || ""));};
  
    // Usar BusinessMenuList (menú simplificado) en lugar de MenuList (menú completo)
    const menuToUse = BusinessMenuList;
  
    return (
      <>
        {menuToUse &&
          menuToUse.map((mainMenu: MenuItem, index) => (
            <Fragment key={index}>
              <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? "d-none" : ""}`}>
                <div>
                  <H6 className={mainMenu.lanClass && mainMenu.lanClass}>{t(mainMenu.title)}</H6>
                </div>
              </LI>
              <MenuLists menu={mainMenu.Items} activeMenu={activeMenu} setActiveMenu={setActiveMenu}  level={0}/>
            </Fragment>
          ))}
      </>
    );
}

export default SidebarMenuList
